import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-premium">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6 footer-column">
            <img src={logo} alt="Booze247 Logo" className="footer-logo-img" />
            <p className="pe-lg-5">
              Premium drinks delivered to your door 24/7. We provide a wide selection of beverages for every occasion, ensuring quality and speed with every order.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/boozedelivery247" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/booze_247" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-icon">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 footer-column">
            <h3>Quick Links</h3>
            <Link to="/" className="footer-link d-block">Home</Link>
            <Link to="/shop" className="footer-link d-block">Shop</Link>
            <Link to="/blog" className="footer-link d-block">Blog</Link>
            <Link to="/contact" className="footer-link d-block">Contact</Link>
          </div>

          <div className="col-lg-3 col-md-6 footer-column">
            <h3>Contact Us</h3>
            <div className="d-flex align-items-start mb-3">
              <MapPin size={18} className="text-danger me-2 mt-1" />
              <span>Cardiff, Wales, CF3 2ER<br />United Kingdom</span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <Phone size={18} className="text-danger me-2" />
              <a href="tel:+44 029 2188 0665" className="footer-link p-0 mb-0">+44 029 2188 0665</a>
            </div>
            <div className="d-flex align-items-center">
              <Mail size={18} className="text-danger me-2" />
              <a href="mailto:Support@booze247.co.uk" className="footer-link p-0 mb-0">Support@booze247.co.uk</a>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 footer-column">
            <h3>Opening Hours</h3>
            <p className="mb-2"><strong>Monday - Sunday:</strong></p>
            <p className="text-danger fw-bold h5">Open 24 Hours</p>
            <p className="small text-muted mt-3">We never sleep, so you can enjoy your favorite drinks anytime!</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="mb-0">&copy; {new Date().getFullYear()} Booze247. All rights reserved. Drink responsibly. 18+</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

